'use client';

import { FeatherAlertTriangle, FeatherLoader, FeatherWand2 } from '@subframe/core';

import { tituloInconsistenciaReceita } from '@/shared/utils/inconsistenciaReceita';

import { Button } from './Button';

interface InconsistenciaReceitaBannerProps {
  issueCount: number;
  isCorrigindo?: boolean;
  onCorrigirTodos: () => void;
}

export function InconsistenciaReceitaBanner({
  issueCount,
  isCorrigindo = false,
  onCorrigirTodos,
}: InconsistenciaReceitaBannerProps) {
  return (
    <div className="border-warning-200 bg-warning-50 flex w-full items-center gap-3 rounded-lg border p-4">
      <FeatherAlertTriangle className="text-warning-600 h-5 w-5 flex-none" />
      <div className="flex flex-1 flex-col">
        <span className="text-body-bold font-body-bold text-warning-900">
          {tituloInconsistenciaReceita(issueCount)}
        </span>
        <span className="text-caption font-caption text-warning-700">
          O nome informado não corresponde ao nome oficial do documento. Corrija ou revise cada
          linha antes de enviar.
        </span>
      </div>
      <Button
        className="flex-none"
        variant="brand-primary"
        icon={isCorrigindo ? <FeatherLoader className="animate-spin" /> : <FeatherWand2 />}
        disabled={isCorrigindo}
        onClick={onCorrigirTodos}
      >
        {isCorrigindo ? 'Revalidando...' : 'Corrigir Todos'}
      </Button>
    </div>
  );
}
